var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-form',{attrs:{"edit":_vm.edit},on:{"cancel":_vm.backToList}})}
var staticRenderFns = []

export { render, staticRenderFns }